/**
 * Geohash decoder utility
 * Converts geohash string to latitude and longitude coordinates
 */

const BASE32 = '0123456789bcdefghjkmnpqrstuvwxyz';
const BITS = [16, 8, 4, 2, 1];

/**
 * Decode geohash to latitude and longitude
 * @param {string} geohash - The geohash string to decode
 * @returns {Object|null} - Object with lat, lng, and bounds, or null if invalid
 */
export function decodeGeohash(geohash) {
  if (!geohash || typeof geohash !== 'string') {
    return null;
  }

  let isEven = true;
  let lat = [-90.0, 90.0];
  let lon = [-180.0, 180.0];
  let latErr = 90.0;
  let lonErr = 180.0;

  for (let i = 0; i < geohash.length; i++) {
    const c = geohash[i];
    const cd = BASE32.indexOf(c);
    
    if (cd === -1) {
      return null; // Invalid character
    }

    for (let j = 0; j < 5; j++) {
      const mask = BITS[j];
      if (isEven) {
        lonErr /= 2;
        if (cd & mask) {
          lon[0] = (lon[0] + lon[1]) / 2;
        } else {
          lon[1] = (lon[0] + lon[1]) / 2;
        }
      } else {
        latErr /= 2;
        if (cd & mask) {
          lat[0] = (lat[0] + lat[1]) / 2;
        } else {
          lat[1] = (lat[0] + lat[1]) / 2;
        }
      }
      isEven = !isEven;
    }
  }

  const latitude = (lat[0] + lat[1]) / 2;
  const longitude = (lon[0] + lon[1]) / 2;

  return {
    lat: latitude,
    lng: longitude,
    latitude: latitude,
    longitude: longitude,
    bounds: {
      sw: { lat: lat[0], lng: lon[0] },
      ne: { lat: lat[1], lng: lon[1] }
    },
    error: {
      lat: latErr,
      lng: lonErr
    }
  };
}

/**
 * Format coordinates for display
 * @param {Object} coords - Coordinates object from decodeGeohash
 * @param {number} precision - Number of decimal places (default: 6)
 * @returns {string} - Formatted string like "47.606200, -122.332100"
 */
export function formatCoordinates(coords, precision = 6) {
  if (!coords) return null;
  return `${coords.lat.toFixed(precision)}, ${coords.lng.toFixed(precision)}`;
}












